import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import {
    getDateDifferenceHumanReadable,
} from '../../../public/utils/common';
import {
    currentTimeSelector,
    currentDateSelector,
} from '../../selectors/domainData';

import styles from './styles.scss';

const propTypes = {
    /**
     * Timestamp for end Date
     */
    end: PropTypes.number,
    /**
     * Timestamp for start Date
     */
    start: PropTypes.number,
    invalidText: PropTypes.string,
    prefix: PropTypes.string,
    suffix: PropTypes.string,
};

const defaultProps = {
    end: undefined,
    start: undefined,
    invalidText: '-',
    prefix: '',
    suffix: '',
};


/**
 * Human Readable Date component provide diff between given and current date
 * (end - start)
 */
@CSSModules(styles, { allowMultiple: true })
class ElapsedDateTime extends React.PureComponent {
    static defaultProps = defaultProps;
    static propTypes = propTypes;

    render() {
        const {
            end,
            start,
            invalidText,
            prefix,
            suffix,
        } = this.props;

        let diff = null;

        if (!(end === undefined || start === undefined)) {
            diff = getDateDifferenceHumanReadable(end, start);
        }

        return (
            <span styleName="elapsed-date-value">
                {
                    diff ?
                        `${prefix}${diff}${suffix}` : invalidText
                }
            </span>
        );
    }
}

const mapStateToDateProps = state => ({
    start: currentDateSelector(state),
});

const mapStateToTimeProps = state => ({
    start: currentTimeSelector(state),
});

/**
 * Update at the end of the day
 */
export const ElapsedDate = connect(mapStateToDateProps)(ElapsedDateTime);

/**
 *  Update at the interval of second
 */
export const ElapsedTime = connect(mapStateToTimeProps)(ElapsedDateTime);



// WEBPACK FOOTER //
// ./src/common/components/ElapsedDateTime/index.js